var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1905 16C12.1905 15.1163 12.8727 14.4 13.7143 14.4H15.2381V17.6H13.7143C12.8727 17.6 12.1905 16.8837 12.1905 16Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7143 12.8H15.2381V9.6H13.7143C12.8727 9.6 12.1905 10.3163 12.1905 11.2C12.1905 12.0837 12.8727 12.8 13.7143 12.8Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7619 16C16.7619 15.1163 17.4441 14.4 18.2857 14.4C19.1273 14.4 19.8095 15.1163 19.8095 16C19.8095 16.8837 19.1273 17.6 18.2857 17.6C17.4441 17.6 16.7619 16.8837 16.7619 16Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2857 9.6H16.7619V12.8H18.2857C19.1273 12.8 19.8095 12.0837 19.8095 11.2C19.8095 10.3163 19.1273 9.6 18.2857 9.6Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7143 19.2H15.2381V20.8C15.2381 21.6837 14.5559 22.4 13.7143 22.4C12.8727 22.4 12.1905 21.6837 12.1905 20.8C12.1905 19.9163 12.8727 19.2 13.7143 19.2Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 4H4V28H28V4ZM13.7143 8C12.0311 8 10.6667 9.43269 10.6667 11.2C10.6667 12.1557 11.0657 13.0136 11.6984 13.6C11.0657 14.1863 10.6667 15.0442 10.6667 16C10.6667 16.9558 11.0657 17.8137 11.6984 18.4C11.0657 18.9863 10.6667 19.8442 10.6667 20.8C10.6667 22.5674 12.0311 24 13.7143 24C15.3975 24 16.7619 22.5673 16.7619 20.8V18.7719C17.2102 19.0442 17.7306 19.2 18.2857 19.2C19.9689 19.2 21.3333 17.7673 21.3333 16C21.3333 15.0442 20.9343 14.1863 20.3016 13.6C20.9343 13.0136 21.3333 12.1557 21.3333 11.2C21.3333 9.4327 19.9689 8 18.2857 8H13.7143Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.fb600da8edd74782bae76ff3e4cda1ad.svg";
export { ForwardRef as ReactComponent };